var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.4,
    viewBox: "0 0 16 14.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5971",
    "data-name": "Group 5971",
    transform: "translate(-14471.107 -21729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-feedback-2044718",
    transform: "translate(14471.107 21729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5946",
    "data-name": "Path 5946",
    d: "M356.759,78.364h0c-.008-1.494-.106-2.534-1.266-2.534h-.845a.422.422,0,0,0-.422.422c0,2.462-.808,2.956-2.112,2.956h-1.689a.422.422,0,0,0-.422.422V84.7a.422.422,0,0,0,.422.422h6.335a1.691,1.691,0,0,0,1.689-1.689V80.053a1.691,1.691,0,0,0-1.689-1.689Zm-5.913,1.689h.845v4.223h-.845Zm6.757,3.378a.846.846,0,0,1-.845.845h-4.223V80.022c1.637-.152,2.437-1.2,2.526-3.348h.431c.359,0,.422.316.422,2.112h0a.422.422,0,0,0,.422.422h.422a.846.846,0,0,1,.845.845Z",
    transform: "translate(-342.448 -75.83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5947",
    "data-name": "Path 5947",
    d: "M129.74,107.937a.394.394,0,0,0-.28.117.4.4,0,0,0-.116.282,1.2,1.2,0,0,1-.348.845,1.186,1.186,0,0,1-.84.351h-3.168a.393.393,0,0,0-.238.08l-2.535,1.914v-1.595a.4.4,0,0,0-.116-.282.4.4,0,0,0-.28-.117H118.65a1.186,1.186,0,0,1-.84-.351,1.2,1.2,0,0,1-.348-.845v-7.176a1.2,1.2,0,0,1,.348-.845,1.186,1.186,0,0,1,.84-.351h7.921a.4.4,0,0,0,0-.8H118.65a1.975,1.975,0,0,0-1.4.585,2,2,0,0,0-.581,1.409v7.176a2,2,0,0,0,.581,1.409,1.975,1.975,0,0,0,1.4.585h2.773v1.994a.4.4,0,0,0,.219.357.394.394,0,0,0,.415-.038l3.063-2.312h3.037a1.975,1.975,0,0,0,1.4-.585,2,2,0,0,0,.581-1.409.4.4,0,0,0-.116-.282.394.394,0,0,0-.28-.117Z",
    transform: "translate(-116.67 -98.321)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c0a1927d85e92252aaf156f79a6c19eb.svg";
export { ForwardRef as ReactComponent };